import { UIText } from './types';

export const UI: UIText = {
  title: 'DraftMyComplaints',
  subtitle: 'Turn a bad experience into a complaint that gets read.',
  labelSender: 'Your name (optional)',
  phSender: '',
  labelCompany: 'Company or Authority Name',
  phCompany: 'e.g., SkyHigh Airlines, City Council...',
  labelDate: 'Date of Incident (optional)',
  labelRecipient: 'Recipient Email (optional)',
  phRecipient: 'claims@company.com',
  labelCC: 'CC (optional)',
  phCC: 'manager@company.com; lawyer@firm.com',
  labelTone: 'Tone of Voice',
  toneFormal: 'Formal & Factual',
  toneAngry: 'Angry & Disappointed',
  toneLegal: 'Strict & Legal',
  labelCompensation: 'Compensation Demand Level',
  compReasonable: 'Reasonable',
  compGoBig: 'Go Big or Go Home!',
  labelDescription: 'What happened',
  phDescription: 'Describe the incident, e.g. a ruined order, a cancelled flight, or a service that never showed up.',
  labelImage: 'Upload Photo (optional)',
  btnGenerate: 'Generate my draft',
  btnGenerating: 'Drafting...',
  previewTitle: 'Email Preview',
  btnDownload: 'Download PDF',
  btnCopy: 'Copy Text',
  btnEmail: 'Open in Email Client',
  alertCopied: 'Email text copied to clipboard!',
  errorGeneric: 'Something went wrong. Please try again.',
  errorMissingKey: 'Server configuration error.',
  companyNameError: 'Please enter the company or authority name.',
  descriptionError: 'Please describe what happened.',
  infoTitle: 'About DraftMyComplaints',
  infoDesc: "DraftMyComplaints writes demand letters for security deposits based on your state's deposit law, and general complaint letters for everything else. Pick a tone, then download a PDF or send it from your email client. No account needed, and nothing you type is stored beyond what it takes to write the draft. This is general information, not legal advice.",
  btnClose: 'Close',
  btnShowDetails: 'Show Optional Fields (Date, Email, Photos)',
  btnHideDetails: 'Hide Optional Fields',
};
